import { render, staticRenderFns } from "./estadisticas-articulo-mas.vue?vue&type=template&id=4f5b271f&scoped=true&"
import script from "./estadisticas-articulo-mas.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-articulo-mas.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-articulo-mas.vue?vue&type=style&index=0&id=4f5b271f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b271f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
